import DeleteIcon from '@atlaskit/icon/core/delete';
import { HIGHLIGHT_DELETE_CLASS } from '@databases/highlights/constants';
import { messages } from '@databases/intl/messages';
import React from 'react';

import { SELECT_VALUE_MENU_ACTIONS } from '../../../select-value-menu/types';
import { CONTEXT_MENU_DELETE_PREVIEW_Z_INDEX } from '../../constants';
import { type SelectionsEffectMenuItemBuilder } from '../types';

const CONTEXT_MENU_DELETE_COLUMN_HIGHLIGHT_ID = 'context-menu-delete-column';

export const deleteCurrentColumnMenuItem: SelectionsEffectMenuItemBuilder = (
  context,
  actions,
  skip
) => {
  if (!context.capabilities.canDeleteFields) {
    return skip;
  }

  return (showDialog) => ({
    key: SELECT_VALUE_MENU_ACTIONS.DELETE_FIELDS,
    content: context.formatMessage(messages['field-actions.delete'], {
      fieldCount: '1',
    }),
    onClick: () => {
      // NOTE: `handleDeleteFields` opens a confirm dialog and writes to Yjs
      // asynchronously from the dialog's onClose. The helper invoked here
      // wraps the confirmed mutation with traceDatabaseAction itself so the
      // timing window starts at confirm, not at this menu click. Avoid
      // wrapping this dialog-open click, otherwise the trace would complete
      // as no-yjs before the user confirms.
      actions.column.handleDeleteFields([context.fieldId], showDialog);
      context.closeMenu();
    },
    onMouseEnter: () => {
      const layer = context.deletePreviewLayer;
      const resolve = context.resolveFieldIdToColIndex;

      if (layer && resolve) {
        const colIndex = resolve(context.fieldId);

        if (colIndex >= 0) {
          layer.add({
            range: {
              id: CONTEXT_MENU_DELETE_COLUMN_HIGHLIGHT_ID,
              anchor: { row: 0, col: colIndex },
              lead: { row: 0, col: colIndex },
            },
            mode: 'column',
            zIndex: CONTEXT_MENU_DELETE_PREVIEW_Z_INDEX,
            className: HIGHLIGHT_DELETE_CLASS,
          });
        }
      }
    },
    onMouseLeave: () => {
      context.deletePreviewLayer?.remove(CONTEXT_MENU_DELETE_COLUMN_HIGHLIGHT_ID);
    },
    elemBefore: <DeleteIcon label="" />,
  });
};
